import { render, staticRenderFns } from "./ping-documents.vue?vue&type=template&id=ffe457fc&v-if=device&"
import script from "./ping-documents.vue?vue&type=script&lang=js&"
export * from "./ping-documents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports